import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

/**
 * ページ共通ヘッダー: タイトル・説明・戻るボタンを一貫した形で表示する。
 * back: 戻り先パス（省略時はブラウザ履歴を1つ戻る）
 */
export default function PageHeader({ title, subtitle, back, actions }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Button
          size="small"
          startIcon={<ArrowBackIcon />}
          onClick={() => (back ? navigate(back) : navigate(-1))}
          sx={{ textTransform: "none" }}
        >
          戻る
        </Button>
        <Typography variant="h5" sx={{ fontWeight: "bold", flexGrow: 1 }}>
          {title}
        </Typography>
        {actions}
      </Box>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
